<div class="wrapper">
  <div class="header">
    <h2 (click)="toggleExpand()">{{title}}</h2>
    <span style="flex: 1 1 auto"></span>
    <h2 *ngIf="subtitle !== null">{{subtitle}}</h2>
    <mat-icon *ngIf="collapsible">{{getIcon()}}</mat-icon>
  </div>
  <div *ngIf="!collapsed">
    <ng-content></ng-content>
  </div>
</div>
